<template>
  <div class="diagram-section">
    <v-row class="mt-4">
      <v-col cols="12" md="6">
        <v-card class="diagram-panel" rounded="lg" variant="flat">
          <div class="diagram-head">
            <span class="diagram-kind">Workflow</span>
            <span class="diagram-shape">Fan-out</span>
          </div>
          <svg class="diagram-svg" viewBox="0 0 460 412" role="img" aria-labelledby="wfT wfD">
            <title id="wfT">Workflow fan-out diagram</title>
            <desc id="wfD">A request fans out to four agents working in parallel; their responses feed into one main agent that produces a single answer.</desc>
            <defs>
              <marker id="dgmA" class="dg-arrow" markerWidth="10" markerHeight="9" refX="6.5" refY="3" orient="auto" markerUnits="userSpaceOnUse">
                <path d="M0 0 L6.5 3 L0 6 Z" />
              </marker>
            </defs>
            <g class="dg-line" fill="none" stroke-width="1.6" marker-end="url(#dgmA)">
              <path d="M230 58 L63 146" /><path d="M230 58 L177 146" /><path d="M230 58 L291 146" /><path d="M230 58 L405 146" />
              <path d="M63 198 L158 264" /><path d="M177 198 L205 264" /><path d="M291 198 L255 264" /><path d="M405 198 L302 264" />
              <path d="M230 324 L230 352" />
            </g>
            <g>
              <rect class="dg-node" x="165" y="16" width="130" height="40" rx="10" />
              <rect class="dg-node" x="16" y="150" width="94" height="48" rx="9" />
              <rect class="dg-node" x="130" y="150" width="94" height="48" rx="9" />
              <rect class="dg-node" x="244" y="150" width="94" height="48" rx="9" />
              <rect class="dg-node" x="358" y="150" width="94" height="48" rx="9" />
              <rect class="dg-acc" x="120" y="270" width="220" height="54" rx="11" />
              <rect class="dg-node" x="165" y="356" width="130" height="40" rx="10" />
            </g>
            <g text-anchor="middle">
              <text class="dg-td" x="230" y="40" font-size="11" letter-spacing="1.6">REQUEST</text>
              <text class="dg-t" x="63" y="179" font-size="14" font-weight="600">Agent</text>
              <text class="dg-t" x="177" y="179" font-size="14" font-weight="600">Agent</text>
              <text class="dg-t" x="291" y="179" font-size="14" font-weight="600">Agent</text>
              <text class="dg-t" x="405" y="179" font-size="14" font-weight="600">Agent</text>
              <text class="dg-t" x="230" y="302" font-size="15" font-weight="700">Main agent</text>
              <text class="dg-td" x="230" y="380" font-size="11" letter-spacing="1.6">ONE ANSWER</text>
            </g>
          </svg>
          <p class="diagram-desc text-medium-emphasis">Several agents take on the same request in parallel. Each works independently, then every response is fed back into one main agent that reads them all and produces a single answer.</p>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="diagram-panel" rounded="lg" variant="flat">
          <div class="diagram-head">
            <span class="diagram-kind">Factory</span>
            <span class="diagram-shape">Chain</span>
          </div>
          <svg class="diagram-svg" viewBox="0 0 460 412" role="img" aria-labelledby="fcT fcD">
            <title id="fcT">Factory chain diagram</title>
            <desc id="fcD">Input passes through a sequence of steps — agent, nested workflow, agent — each step's output feeding the next step's input, ending in a result.</desc>
            <defs>
              <marker id="dgmB" class="dg-arrow" markerWidth="10" markerHeight="9" refX="6.5" refY="3" orient="auto" markerUnits="userSpaceOnUse">
                <path d="M0 0 L6.5 3 L0 6 Z" />
              </marker>
            </defs>
            <g class="dg-line" fill="none" stroke-width="1.6" marker-end="url(#dgmB)">
              <path d="M230 56 L230 88" /><path d="M230 144 L230 174" /><path d="M230 230 L230 260" /><path d="M230 316 L230 346" />
            </g>
            <g class="dg-dot">
              <circle cx="230" cy="72" r="3.1" /><circle cx="230" cy="159" r="3.1" /><circle cx="230" cy="245" r="3.1" /><circle cx="230" cy="331" r="3.1" />
            </g>
            <g>
              <rect class="dg-node" x="165" y="16" width="130" height="40" rx="10" />
              <rect class="dg-node" x="110" y="92" width="240" height="52" rx="11" />
              <rect class="dg-acc" x="110" y="178" width="240" height="52" rx="11" />
              <rect class="dg-node" x="110" y="264" width="240" height="52" rx="11" />
              <rect class="dg-node" x="165" y="350" width="130" height="40" rx="10" />
            </g>
            <g text-anchor="middle">
              <text class="dg-td" x="230" y="40" font-size="11" letter-spacing="1.6">INPUT</text>
              <text class="dg-t" x="230" y="123" font-size="15" font-weight="600">Agent</text>
              <text class="dg-t" x="230" y="209" font-size="15" font-weight="700">Workflow</text>
              <text class="dg-t" x="230" y="295" font-size="15" font-weight="600">Agent</text>
              <text class="dg-td" x="230" y="374" font-size="11" letter-spacing="1.6">RESULT</text>
            </g>
          </svg>
          <p class="diagram-desc text-medium-emphasis">Steps run in sequence. Each step's output becomes the next step's input — and any step can be a single agent or an entire workflow nested inside.</p>
        </v-card>
      </v-col>
    </v-row>
    <p class="diagram-note text-disabled">Workflows fan out · factories chain · compose them however the work demands.</p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class PatternDiagrams extends Vue {}
</script>

<style scoped lang="scss">
.diagram-panel {
  padding: 26px 24px;
  background: rgb(var(--v-theme-surface-panel));
  border: 1px solid var(--l-border);
  height: 100%;
}
.diagram-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}
.diagram-kind {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.diagram-shape {
  font-family: var(--l-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-accent-ink));
}
.diagram-svg {
  display: block;
  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 16px auto;
}
.diagram-desc {
  font-size: 14px;
  line-height: 1.6;
  margin: 6px 0 0;
  text-wrap: pretty;
}
.diagram-note {
  font-family: var(--l-mono);
  font-size: 12px;
  letter-spacing: 0.06em;
  text-align: center;
  margin: 26px 0 0;
}

/* SVG theme mapping (design --dg-* vars → theme tokens, per theme) */
.dg-line {
  stroke: rgba(var(--v-theme-on-surface), 0.34);
}
.dg-arrow path {
  fill: rgba(var(--v-theme-on-surface), 0.34);
}
.v-theme--light .dg-line {
  stroke: rgba(var(--v-theme-on-surface), 0.36);
}
.v-theme--light .dg-arrow path {
  fill: rgba(var(--v-theme-on-surface), 0.36);
}
.dg-node {
  fill: rgb(var(--v-theme-theme-code));
  stroke: rgb(var(--v-theme-border-color));
  stroke-width: 1.4;
}
.v-theme--light .dg-node {
  /* white plates against the cream panel, matching the brand-logo chips */
  fill: #ffffff;
  stroke: rgba(var(--v-theme-on-surface), 0.18);
}
.dg-acc {
  fill: rgba(var(--v-theme-msq-yellow), 0.16);
  stroke: rgb(var(--v-theme-msq-yellow));
  stroke-width: 1.7;
}
.v-theme--light .dg-acc {
  fill: rgba(var(--v-theme-msq-yellow), 0.22);
  stroke: rgb(var(--v-theme-msq-yellow-darken-1));
}
.dg-t {
  fill: rgb(var(--v-theme-on-surface));
}
.dg-td {
  font-family: var(--l-mono);
  fill: rgba(var(--v-theme-on-surface), 0.5);
}
.dg-dot {
  fill: rgb(var(--v-theme-msq-yellow));
}
.v-theme--light .dg-dot {
  fill: rgb(var(--v-theme-msq-yellow-darken-1));
}
</style>
